export default __webpack_public_path__ + "static/media/topic2-quiz-bg.f0ec122f.png";